import React from 'react'
import PropTypes from 'prop-types'

import Arrow from 'lib/icons/arrow'

const DEFAULT_STROKE_COLOR = '#82888a'

const isPrimitive = option => typeof option === 'string' || typeof option === 'number'

const SelectOption = ({ isPrimitive, option, valueKey, labelKey }) => {
  if (isPrimitive) {
    return <option value={option}>{option}</option>
  } else {
    return (
      <option value={valueKey ? option[valueKey] : option.id || option.value}>
        {labelKey ? option[labelKey] : option.name || option.label}
      </option>
    )
  }
}

const Select = ({
  dataAttr,
  value,
  name,
  placeholder,
  selectClassName,
  multiple,
  options,
  disabled,
  valueKey,
  labelKey,
  style,
  onChange,
  onValueChange,
  withOrder,
  strokeColor
}) => {
  const mainOptions = withOrder ? options.filter(option => option.order === 1) : options
  const secondaryOptions = withOrder ? options.filter(option => option.order === 2) : null

  const handleChange = event => {
    if (onChange) {
      onChange(event)
    }
    if (onValueChange) {
      onValueChange(event.target.value)
    }
  }

  return (
    <div className={`super-select${placeholder && !value ? ' placeholder' : ''}`} style={style} data-attr={dataAttr}>
      <select
        name={name}
        className={`input-text inline${selectClassName ? ' ' + selectClassName : ''}`}
        multiple={!!multiple}
        disabled={disabled}
        value={value}
        onChange={handleChange}
      >
        {placeholder ? <option value=''>{placeholder}</option> : null}
        {mainOptions.map(option => (
          <SelectOption
            isPrimitive={isPrimitive(option)}
            key={isPrimitive(option) ? option : valueKey ? option[valueKey] : option.key || option.id || option.value}
            value={option.id || option.value}
            option={option}
            valueKey={valueKey}
            labelKey={labelKey}
          />
        ))}
        {secondaryOptions && (
          <optgroup label='-------'>
            {secondaryOptions.map(option => (
              <SelectOption
                isPrimitive={isPrimitive(option)}
                key={
                  isPrimitive(option) ? option : valueKey ? option[valueKey] : option.key || option.id || option.value
                }
                option={option}
                valueKey={valueKey}
                labelKey={labelKey}
              />
            ))}
          </optgroup>
        )}
      </select>
      <Arrow isMenu stroke={strokeColor || DEFAULT_STROKE_COLOR} dir='down' />
    </div>
  )
}

SelectOption.propTypes = {
  isPrimitive: PropTypes.bool,
  option: PropTypes.string,
  valueKey: PropTypes.string,
  labelKey: PropTypes.string
}

Select.propTypes = {
  dataAttr: PropTypes.string,
  value: PropTypes.any,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  selectClassName: PropTypes.string,
  multiple: PropTypes.bool,
  options: PropTypes.array,
  disabled: PropTypes.bool,
  valueKey: PropTypes.string,
  labelKey: PropTypes.string,
  style: PropTypes.object,
  onChange: PropTypes.func,
  onValueChange: PropTypes.func,
  withOrder: PropTypes.bool,
  strokeColor: PropTypes.string
}

export default Select
